// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3qlSL","select":"Header_select__3v_1g","clinic":"Header_clinic__qVb_y"};